module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/avatars/male-2-4148003e376e80c5b26da4b8d2636576.jpg";